import axios from "axios";

// Create an instance of axios
// baseURL: "https://ombor2024.jprq.site", // Replace with your API URL
const axiosInstance = axios.create({
  baseURL: "https://api.mineralmarket.uz/", // Replace with your API URL
  timeout: 1000000, // Optional timeout
  headers: {
    "Content-Type": "application/json",
    // Add any other custom headers if needed
  },
});

// Optional: Add request and response interceptors
axiosInstance.interceptors.request.use(
  (config) => {
    // Modify config before the request is sent (e.g., add auth token)
    const token = localStorage.getItem("token"); // Example: get token from storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Redirect to /auth page
      window.location.href = "/auth";
    }
    // Handle request error
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    // Handle the response data
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Redirect to /auth page
      window.location.href = "/auth";
    }
    // Handle response errors (e.g., show notification or redirect)
    return Promise.reject(error);
  }
);

export default axiosInstance;
